import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { problems } from '../data/problems';
export function ProblemSection() {
  return <section className="bg-stage blueprint py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-217" data-mp="2lqgv0knlf1t1">
      <div className="mx-auto max-w-4xl px-4" data-id="element-218" data-mp="30jaias93wm89">
        <div className="text-center" data-id="element-219" data-mp="2vq7medgux0ow">
          <p className="text-xs font-extrabold uppercase tracking-[.18em] text-safety" data-id="element-220" data-mp="2vp6dofnbcqac">La realidad profesional</p>
          <h2 id="problem-title" className="mx-auto mt-3 max-w-3xl text-balance text-3xl font-extrabold leading-tight text-white sm:text-4xl" data-id="element-221" data-mp="39jqls1puntd4">
            ¿Cuántas clases más vas a preparar sobre Seguridad e Higiene sin tener el material correcto?
          </h2>
          <p className="mx-auto mt-5 max-w-3xl leading-relaxed text-mutedDark" data-id="element-222" data-mp="3eia9a6k3dd7l">
            Buscás información en internet que no tiene secuencia didáctica ni menciona la realidad de los riesgos
            laborales en Argentina. Armás planificaciones desde cero cada ciclo lectivo. Y cuando un alumno pregunta cómo
            identificar peligros en una máquina, qué normativa argentina regula los riesgos eléctricos, cómo hacer un plan
            de evacuación en una escuela técnica, cómo seleccionar EPP correctamente, cómo actuar ante una emergencia, o
            qué significa realmente trabajar de forma segura en una empresa argentina en 2026, no tenés una respuesta que
            los enganche con la realidad del campo de la prevención argentino.
          </p>
          <p className="mt-4 font-bold text-safety" data-id="element-223" data-mp="171wo6xri37sd">No es falta de vocación profesional. Es que nadie armó el sistema completo para vos.</p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="panel-dark mt-9 rounded-xl border border-lineDark p-6 sm:p-8" data-id="element-224" data-mp="1bzogvtzyyxxm">
          <p className="mb-5 font-display text-xl font-bold text-white" data-id="element-225" data-mp="p00lnsf9rr06">Esto te está pasando ahora mismo:</p>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-226" data-mp="k1pbthoz5ghy">
            {problems.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-onDark" data-id="element-227" data-mp="y0yt6kox2gni">
                <span className="mt-0.5 shrink-0 rounded-md bg-danger/20 p-1" data-id="element-228" data-mp="xym2nj53exyu">
                  <XIcon className="h-3.5 w-3.5 text-danger" aria-hidden="true" data-id="element-229" data-mp="ty24cc8s9ob4" />
                </span>
                {item}
              </li>)}
          </ul>
        </motion.div>

        <p className="mt-8 text-center font-bold text-safety" data-id="element-230" data-mp="12z8r3320zvct">
          ¿Y si esta fuera la última semana que enseñás Seguridad e Higiene sin tener todo resuelto?
        </p>

        <p className="mx-auto mt-6 max-w-3xl text-center leading-relaxed text-mutedDark" data-id="element-231" data-mp="1cpl6kguzgyc3">
          Con el MEGAPACK SEGURIDAD E HIGIENE LISTO, tu próxima clase ya empieza diferente. Tus alumnos no aprenden
          prevención como un conjunto de reglas abstractas: aprenden que cada medida de seguridad existe porque alguien
          decidió que la vida y la salud de los trabajadores son derechos fundamentales.
        </p>
      </div>
    </section>;
}